export class PaginatedResult {
  constructor(data = [], pagination = null) {
    this.data = data;
    this.currentPage = pagination?.currentPage || 1;
    this.pageSize = pagination?.pageSize || 9;
    this.totalItems = pagination?.totalItems || 0;
    this.totalPages = pagination?.totalPages || 0;
  }
}

export class PagingParams {
  constructor(pageNumber = 1, pageSize = 9) {
    this.pageNumber = pageNumber;
    this.pageSize = pageSize;
    this.search = "";
    this.type = "";
    this.sort = "";
  }
}
